



































































































































import { Vue, Prop, Component } from "vue-property-decorator";
import Icon from "../../../globalUsage/Icon.vue";
import { namespace } from "vuex-class";
import { POST_TYPE } from "@/services/ApiEndpoints";
const Auth = namespace("Auth");
const Assets = namespace("Assets");
const Investments = namespace("Investments");

@Component({
  components: {
    Icon,
  },
})
export default class SelectConversion extends Vue {
  @Prop() goBack!: void;
  @Prop() goNext!: Function;
  @Prop() closeModal!: void;
  @Prop() selectedCoin!: any;
  @Prop() acceptedCoins!: any;
  @Prop() count!: number;
  @Prop() postType!: string;
  @Prop() assetData!: any;

  showLoading: boolean = false;
  show: false = false;

  data: any = [];
  acceptedCoinsList: any = [];
  totalRecords: number = 0;
  page: number = 1;

  filterUrl(url) {
    if (url != null && url != "") {
      return url.split("?")[0];
    }
    return "";
  }

  @Auth.Getter
  private userGetter!: any;

  @Assets.Action
  private getAssets!: (data: any) => Promise<any>;

  @Investments.Action
  private getInvestments!: (data: any) => Promise<any>;

  Apply() {
    if (this.acceptedCoinsList.length) {
      this.acceptedCoinsList?.map((item) => {
        if (item.selectedCoin) {
          if (this.acceptedCoins.indexOf(item) === -1) {
            this.acceptedCoins.push(item);
          }
        }
      });
    }
    this.goNext();
  }

  addCoin() {
    this.acceptedCoinsList.push({
      selectedCoin: null,
      currentPrice: 0,
      currentProfit: 0,
      conversionCoin: 0,
      showCoinList: false,
    });
  }

  removeCoin(index) {
    this.$delete(this.acceptedCoinsList, index);
    this.$delete(this.acceptedCoins, index);
    this.setConversionCoin();
  }

  clickCoin(item, index) {
    this.acceptedCoinsList[index].selectedCoin = item;
    this.acceptedCoinsList[index].showCoinList = false;
    this.setConversionCoin();
  }

  setConversionCoin() {
    let amount = 0;
    console.log("this is conversion - ", this.acceptedCoinsList);
    if (this.acceptedCoinsList.length > 0) {
      amount =
        (this.selectedCoin.price * this.count) / this.acceptedCoinsList.length;
      if (isNaN(amount)) amount = 0;

      this.acceptedCoinsList.forEach((element) => {
        let conversionCoin = 0;
        if (element.selectedCoin.price != 0) {
          conversionCoin = amount / element.selectedCoin.price;
          if (isNaN(conversionCoin)) conversionCoin = 0;
        }

        element.currentPrice =
          element.selectedCoin.price < 0
            ? "-$" + element.selectedCoin.price * -1
            : "$" + element.selectedCoin.price;
        element.currentProfit = 0;
        element.conversionCoin = Number(conversionCoin.toFixed(2));
      });
    }
  }

  getAssetsData(page: number) {
    this.getAssets({
      access: this.userGetter.access,
      page: page,
      page_size: 100,
    }).then((response) => {
      this.page = page;
      if (response.data.count) {
        this.totalRecords = response.data.count;
      }
      if (response.data.results) {
        if (page == 1) {
          this.data = [];
        }
        this.data = this.data.concat(response.data.results);
      }
    });
  }

   getInvestmentData() {
    let data = {
      page: 1,
      page_size: 10,
      access: this.userGetter.access,
    };
    this.getInvestments(data).then((res) => {
      if (res.data.results.length) {
        this.data = [];
        res.data.results.forEach((element) => {
          this.data.push(element.asset);
        });
      }
    });
  }

  created() {
   if(this.postType == POST_TYPE.BUY ) this.getInvestmentData()
   else this.getAssetsData(1);
  }

  mounted() {
    if (this.acceptedCoins?.length) {
      this.acceptedCoins.filter((item) => {
        if (this.acceptedCoinsList.indexOf(item) === -1) {
          this.acceptedCoinsList.push(item);
        }
      });
    }
  }
}
